/* eslint-disable no-debugger */
/* eslint-disable default-param-last */
import { getConstants } from '../actions/actionType';

export function AdminUserPagination(state = {}, action) {
    switch (action.type) {
    case getConstants.ADD_PAGINATION:
        return {
            type: 'ADD_PAGINATION',
            pageData: action.user,
        };
    case getConstants.REMOVE_PAGINATION:
        return {
            type: 'REMOVE_PAGINATION',
            message: action.user,
        };
    default:
        return state;
    }
}
